module.exports = __webpack_public_path__ + "img/Eduzz-5-en.9edc5d5f.png";